export default "__VITE_ASSET__BtOUc8pH__"